module.exports = __webpack_public_path__ + "./kit/docs/img/unity.2eff56fa8a577d4c9c7387622fe495d2.svg";